import React from 'react'
import useApiService from 'services/api'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { filterStoreRepo } from '../../../../Filters/FilterStore'
import FilterModal, {
  QuickFilterGroup,
} from '../../../../Filters/components/FilterModal'
import { QuickShowHiddenFilter } from 'components/Filters/fields/QuickFilter'
import { FilterIdentifier } from 'models/saved_view'
import { CommonFiltersetAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetAccountGroup'
import { CommonFiltersetGooglePlaceGroup } from '../../GooglePlaceBase/GooglePlaceBaseTable/CommonFiltersetGooglePlaceGroup'
import { LodgingAmenitiesFilterGroup } from '../LodgingAmenitiesFilterGroup'
import { LODGING_COLUMNS } from '../LodgingColumnsInfo'

export function LodgingFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = useApiService()
  const { enableLodgingHotelAmenities } = useFeatureFlagService()
  const { data: campaignOptions } = api.useGetCampaignsOptions(
    'lodging-hospitality',
    undefined,
    true
  )

  const lodgingFilterStore = filterStoreRepo.getStore(filterIdentifier)

  return (
    <FilterModal identifier={filterIdentifier} store={lodgingFilterStore}>
      <QuickFilterGroup>
        <QuickShowHiddenFilter filterStore={lodgingFilterStore} />
      </QuickFilterGroup>
      <CommonFiltersetAccountGroup
        filterStore={lodgingFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <CommonFiltersetGooglePlaceGroup
        filterStore={lodgingFilterStore}
        columns={LODGING_COLUMNS}
        companyType="lodging-hospitality"
      />
      {enableLodgingHotelAmenities && (
        <LodgingAmenitiesFilterGroup filterStore={lodgingFilterStore} />
      )}
    </FilterModal>
  )
}
